import { defineComponent, ref, watch, h, type PropType } from "vue";
import { router } from './index';

export default defineComponent({
  name: 'RoutePath',
  props: {
    path: {
      type: String as PropType<string>,
      required: true,
    },
  },
  setup(props, { slots }) {
    const { route: myRoute } = router!.matchPath(props.path);
    let elClass = ref({});

    watch([router?.currentRoute, router?.currentPath], () => {
      elClass.value = {
        'route': true,
        'route-active': myRoute ? router!.isActiveRoute(myRoute) : false,
        'route-hyper-active': router!.isCurrentPath(props.path),
      }
    }, { immediate: true });
    return () => {
      return h(
        'a',
        {
          onClick: (e) => { router!.dispatch({ path: props.path }); e.preventDefault(); },
          class: elClass.value,
          href: props.path,
        },
        slots.default && slots.default()
      );
    };
  },
});
